import React from 'react';
import Icon from '../../../components/AppIcon';

const AnomalyCard = ({ anomaly }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high': return 'error';
      case 'medium': return 'warning';
      case 'low': return 'accent';
      default: return 'muted';
    }
  };

  return (
    <div className={`
      p-3 rounded-lg border-2 transition-smooth
      ${anomaly?.severity === 'high' ? 'border-error/30 bg-error/5' : ''}
      ${anomaly?.severity === 'medium' ? 'border-warning/30 bg-warning/5' : ''}
      ${anomaly?.severity === 'low' ? 'border-accent/30 bg-accent/5' : ''}
    `}>
      <div className="flex items-start gap-3 mb-2">
        <div className={`
          w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0
          bg-${getSeverityColor(anomaly?.severity)}/10
        `}>
          <Icon 
            name="AlertCircle" 
            size={16} 
            color={`var(--color-${getSeverityColor(anomaly?.severity)})`}
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-body font-semibold text-sm text-foreground">
              {anomaly?.type}
            </h4>
            <span className={`
              px-2 py-0.5 rounded text-xs font-medium
              bg-${getSeverityColor(anomaly?.severity)}/10 text-${getSeverityColor(anomaly?.severity)}
            `}>
              {anomaly?.severity}
            </span>
          </div>
          <p className="caption text-muted-foreground mb-2">
            {anomaly?.description}
          </p>
          {anomaly?.recommendation && (
            <div className="flex items-start gap-2 mt-2 pt-2 border-t border-border">
              <Icon name="Lightbulb" size={14} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
              <p className="caption text-foreground">
                <span className="font-medium">Recommendation:</span> {anomaly?.recommendation}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnomalyCard;
